import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileView } from '../models/vdr-file-view.model';

export interface UploadVDRFileRequest {
    engagementId: number;
    temporaryFileId: number;
    folderPath: string;
    fileName: string;
}

export const UploadVDRFile = createAsyncThunk(
    'dataRoom/uploadFile',
    async (
        { engagementId, temporaryFileId, folderPath, fileName }: UploadVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file`,
                { temporaryFileId, folderPath, fileName }
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not upload file at the moment.',
                    'error'
                );
                throw new Error('Failed to upload file');
            }

            return response.data as VDRFileView;
        } catch (error) {
            createNotification(
                'An error occurred while uploading file.',
                'error'
            );
            throw error;
        }
    }
);

